///<reference path="../../../../../ga-gtag.d.ts" />
import React, { useCallback, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { FormHandles } from "@unform/core";
import { Form } from "@unform/web";
import { cpf, cnpj } from "cpf-cnpj-validator";
import { Input } from "../../../Inputs/InputRef/";
import ModalCEP from "../../../Modais/ModalCEP";
import Toast from "../../../Toast/Toast";
import error from "../../../Toast/Image/error.svg";
import { gtag, install } from "ga-gtag";
import check from "../../../Toast/Image/check.svg";
import {
  BigTitle,
  DivForm,
  DivResponsavel,
  DivPF,
  DivFatura,
  DivEmpresa,
  DivInicio,
  InputLabelRadio,
  DivTableDrag,
  DivButton,
} from "./styles";

import { IDataForm } from "../../../../@Types/index";
import Estados from "../../../../utils/Estados/Estados.json";
import Cidades from "../../../../utils/Cidades/Cidades.json";
import api from "../../../../services/api";
import getValidationErrors from "../../../../utils/getValidationErrors";
import {
  readDataStorage,
  writeStorage,
} from "../../../../utils/storage/storage";
import { useProgress } from "../../../../hooks/progress";
import Button from "@mui/material/Button";
import { InputFileMultiple } from "../../../Inputs/InputFileMultiple";
import { AxiosError } from "axios";
import { Tooltip } from "@mui/material";

type UploadRes = {
  signedUrl: string;
  filename: string;
  baseUrl: string;
};

const HolderData: React.FC = () => {
  const { setLoad } = useProgress();
  const localStorageCard = readDataStorage("card");
  const { idCard, pessoa, estado } = readDataStorage("home");
  const { estado: initialEstado } = readDataStorage("home");
  const bancosStorage = readDataStorage("bancos");
  const [defaultEstado, setDefaultEstado] = useState<number>(
    Estados.map((el) => el.id).indexOf(initialEstado)
  );

  const [cidades /*setCidades*/] = useState<any>(Cidades);
  const [defaultCity, setDefaultCity] = useState<number>(0);
  const [dadosEstado, setDadosEstado] = useState("");
  const [formaPagamento, setFormaPagamento] = useState("Pix");
  const [bancos, setBancos] = useState<any>([]);
  const [modalIsOpenCEP, setIsOpenCEP] = useState(false);
  const [CEPvalido, setCEPvalido] = useState();
  const [errorsAttr, setErrorsAttr] = useState<string[]>([]);
  const useFormRef = useRef<FormHandles>(null);
  const [numeroInstalacao, setNumeroInstalacao] = useState(
    localStorageCard?.NumeroInstalacao
  );
  const [list, setList] = useState<any>([]);
  const [uploadedImage, setUploadedImage] = useState<any>(null);
  const [files, setFiles] = useState<FileList | null>(null);
  const [fotos, setFotos] = useState<
    { url: string; nomeArquivo: string }[] | []
  >([]);

  let toastProperties: {
    id: number;
    title: string;
    description: string;
    backgroundColor: string;
    icon: any;
  } | null = null;

  const showToast = useCallback((type: any) => {
    const id = Math.floor(Math.random() * 101 + 1);

    switch (type) {
      case "CEP":
        // eslint-disable-next-line
        toastProperties = {
          id,
          title: "",
          description: "Cidade e Estado são alterados somente através do CEP",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "error":
        toastProperties = {
          id,
          title: "",
          description: "Erro ao enviar dados",
          backgroundColor: "#D72828",
          icon: error,
        };
        break;
      case "errorSend":
        toastProperties = {
          id,
          title: "",
          description: "Erro ao deletar fatura",
          backgroundColor: "#D72828",
          icon: error,
        };
        break;
      case "CEPDiferente":
        toastProperties = {
          id,
          title: "",
          description: "Alteração de estado não permitida",
          backgroundColor: "#D72828",
          icon: error,
        };
        break;
      case "ErroCEP":
        toastProperties = {
          id,
          title: "",
          description: "Não encontramos o CEP informado",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "NenhumBanco":
        toastProperties = {
          id,
          title: "",
          description: "Débito automático indisponível para esta UF",
          backgroundColor: "#d72828",
          icon: error,
        };
        break;
      case "Limite":
        toastProperties = {
          id,
          title: "",
          description: "Limite de caracteres atingido",
          backgroundColor: "#d72828",
          icon: error,
        };
        break;
      case "Sanitize":
        toastProperties = {
          id,
          title: "",
          description: "Caracteres não permitidos. Revise seu e-mail",
          backgroundColor: "#d72828",
          icon: error,
        };
        break;

      case "LimiteTamanhoArquivo":
        toastProperties = {
          id,
          title: "",
          description: "Arquivo excede o tamanho máximo de 5Mb",
          backgroundColor: "#d72828",
          icon: error,
        };
        break;
      case "catchListBanks":
        toastProperties = {
          id,
          title: "",
          description: "Falha ao listar bancos",
          backgroundColor: "#d72828",
          icon: error,
        };
        break;
      case "faturaExcluida":
        toastProperties = {
          id,
          title: "",
          description: "Fatura excluída",
          backgroundColor: "#6C5AF4",
          icon: check,
        };
        break;

      default:
        setList([]);
    }
    setList([...list, toastProperties]);
  }, []);

  const closeModal = () => {
    setIsOpenCEP(false);
    setLoad(false);
  };

  const handleChangeStepperBack = useCallback(async () => {
    setLoad(true);
    await api
      .post(`/csp/proposta/gerar/`, {
        idCard: idCard,
        concessionaria: localStorageCard?.Concessionaria,
        estado: estado,
        subClasse: localStorageCard?.Subclasse,
        classe: localStorageCard?.Classe,
        consumo: {
          jan: localStorageCard?.Jan,
          fev: localStorageCard?.Fev,
          mar: localStorageCard?.Mar,
          abr: localStorageCard?.Abr,
          mai: localStorageCard?.Mai,
          jun: localStorageCard?.Jun,
          jul: localStorageCard?.Jul,
          ago: localStorageCard?.Ago,
          set: localStorageCard?.Set,
          out: localStorageCard?.Out,
          nov: localStorageCard?.Nov,
          dez: localStorageCard?.Dez,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          writeStorage({
            key: "consumo",
            object: {
              arvoresCultivadas: res.data["mensagem"]["arvoresCultivadas"],
              carbonoEvitado: res.data["mensagem"]["carbonoEvitado"],
              economiaVerde: res.data["mensagem"]["economiaVerde"],
              economiaVerdeAno2: res.data["mensagem"]["economiaVerdeAno2"],
              economiaVerdeAno3: res.data["mensagem"]["economiaVerdeAno3"],
              economiaVerdeAno4: res.data["mensagem"]["economiaVerdeAno4"],
              economiaVerdeAno5: res.data["mensagem"]["economiaVerdeAno5"],
              economiaAmarela: res.data["mensagem"]["economiaAmarela"],
              economiaAmarelaAno2: res.data["mensagem"]["economiaAmarelaAno2"],
              economiaAmarelaAno3: res.data["mensagem"]["economiaAmarelaAno3"],
              economiaAmarelaAno4: res.data["mensagem"]["economiaAmarelaAno4"],
              economiaAmarelaAno5: res.data["mensagem"]["economiaAmarelaAno5"],
              economiaVermelhaI: res.data["mensagem"]["economiaVermelhaI"],
              economiaVermelhaIAno2:
                res.data["mensagem"]["economiaVermelhaIAno2"],
              economiaVermelhaIAno3:
                res.data["mensagem"]["economiaVermelhaIAno3"],
              economiaVermelhaIAno4:
                res.data["mensagem"]["economiaVermelhaIAno4"],
              economiaVermelhaIAno5:
                res.data["mensagem"]["economiaVermelhaIAno5"],
              economiaVermelhaII: res.data["mensagem"]["economiaVermelhaII"],
              economiaVermelhaIIAno2:
                res.data["mensagem"]["economiaVermelhaIIAno2"],
              economiaVermelhaIIAno3:
                res.data["mensagem"]["economiaVermelhaIIAno3"],
              economiaVermelhaIIAno4:
                res.data["mensagem"]["economiaVermelhaIIAno4"],
              economiaVermelhaIIAno5:
                res.data["mensagem"]["economiaVermelhaIIAno5"],
              economiaEscassez: res.data["mensagem"]["economiaEscassez"],
              economiaEscassezAno2:
                res.data["mensagem"]["economiaEscassezAno2"],
              economiaEscassezAno3:
                res.data["mensagem"]["economiaEscassezAno3"],
              economiaEscassezAno4:
                res.data["mensagem"]["economiaEscassezAno4"],
              economiaEscassezAno5:
                res.data["mensagem"]["economiaEscassezAno5"],
              kmCarroEletrico: res.data["mensagem"]["kmCarroEletrico"],
              mensalidade: res.data["mensagem"]["mensalidade"],
              concessionaria: res.data["mensagem"]["concessionaria"],
              subClasse: res.data["mensagem"]["subClasse"],
              classe: res.data["mensagem"]["classe"],
              consumoMinimo: res.data["mensagem"]["consumoMinimo"],
              economiaAnual: res.data["mensagem"]["economiaAnual"],
              mediaFinal: res.data["mensagem"]["mediaFinal"],
            },
          });
          setLoad(false);
          window.location.href = "/onboarding/step/2";
        } else {
          setLoad(false);
        }
      });
    setLoad(false);
  }, [
    localStorageCard?.Jan,
    localStorageCard?.Fev,
    localStorageCard?.Mar,
    localStorageCard?.Abr,
    localStorageCard?.Mai,
    localStorageCard?.Jun,
    localStorageCard?.Jul,
    localStorageCard?.Ago,
    localStorageCard?.Set,
    localStorageCard?.Out,
    localStorageCard?.Nov,
    localStorageCard?.Dez,
    estado,
    idCard,
    setLoad,
    localStorageCard?.Classe,
    localStorageCard?.Subclasse,
    localStorageCard.Concessionaria,
  ]);

  const listBanks = useCallback(
    async (estado: any) => {
      setLoad(true);
      await api
        .get("/csp/banco/listar/" + estado)
        .then((response) => {
          let localBanks = [];
          const {
            data: {
              mensagem: { bancos },
            },
          } = response;
          for (const k in bancos) {
            const { nomBan } = bancos[k];
            localBanks.push({ value: bancos[k], label: nomBan });
          }
          setBancos(localBanks);
          //setBancosPR("Santander");
        })
        .catch((err) => {
          setLoad(false);
          console.error(err);
        });
      setLoad(false);
    },
    [setLoad]
  );

  useEffect(() => {
    if (Array.isArray(bancos) && bancos.length === 0) {
      setBancos(bancosStorage?.bancosStorage);
    }
  }, [
    pessoa,
    bancos,
    bancosStorage?.bancosStorage,
  ]);

  useEffect(() => {
    install("AW-380215018");
  });

  function disableInputCep() {
    showToast("CEP");
  }

  const onSanitizeValueDay = useCallback((e: any) => {
    const { value } = e.target;
    let newValue = value.replace(/\D/g, "");
    if (newValue) {
      if (newValue >= 1 && newValue <= 31) {
        e.target.value = value;
        return;
      }
    }
    e.target.value = "";
  }, []);

  const handleChangeTelefone = useCallback((e: any) => {
    const { value } = e.target;
    if (value.length <= 14) {
      e.target.value = value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1");
    } else {
      e.target.value = value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1");
    }
  }, []);

  const handleChangeCEP = useCallback((e: any) => {
    const { value } = e.target;
    e.target.value = value
      .replace(/\D/g, "")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .replace(/(-\d{3})(\d+?)$/, "$1");
  }, []);

  useEffect(() => {
    if (!dadosEstado) {
      setDadosEstado(localStorageCard?.Estado);
    }

    if (localStorageCard?.CEPvalidoCard === 1) {
      setCEPvalido(localStorageCard?.CEPvalidoCard);
    }

    if (localStorageCard?.FormaPagamento === "Boleto/Pix") {
      setFormaPagamento("Pix");
    }
  }, [
    setCEPvalido,
    localStorageCard?.CEPvalidoCard,
    localStorageCard?.FormaPagamento,
    dadosEstado,
    localStorageCard?.Estado,
  ]);

  const [isGoias, setIsGoias] = useState(false);
  const [canProceedToInvoiceData, setCanProceedToInvoiceData] = useState(false);

  const handleBlurCEP = useCallback(
    (e: any) => {
      const { value } = e.target;
      let cep = value.replace(/\D/g, "");

      setCanProceedToInvoiceData(false);
      setIsGoias(false);
      useFormRef.current?.setFieldValue("numeroInstalacao", "");
      if (cep.length === 8) {
        api
          .get(`/csp/consultacep/cep/${cep}`)
          .then((response) => {
            if (response.status === 200) {
              setCEPvalido(response.data.message.valido);
              if (response.data.message.valido === 1) {
                const { message } = response.data;
                if (localStorageCard?.Estado === message.uf) {
                  setCanProceedToInvoiceData(true);
                  if (message) {
                    setIsGoias(message.siglauf === "GO");
                    listBanks(message.siglauf);
                    useFormRef.current?.setFieldValue(
                      "enderecobairro",
                      message.bairro
                    );
                    useFormRef.current?.setFieldValue(
                      "enderecologradouro",
                      message.logradouro
                    );
                    useFormRef.current?.setFieldValue(
                      "enderecocomplemento",
                      message.complemento
                    );
                    useFormRef.current?.setFieldValue(
                      "enderecocidade",
                      message.localidade
                    );
                    useFormRef.current?.setFieldValue(
                      "enderecoestado",
                      message.uf
                    );
                    const indexUf = Estados.map((el) => el.id).indexOf(
                      message.uf
                    );
                    setDadosEstado(message.uf);
                    if (indexUf !== -1) {
                      setDefaultEstado(indexUf);
                    }
                    const indexCity = cidades
                      .map((el: { label: any }) => el.label)
                      .indexOf(message.localidade);
                    if (indexCity !== -1) {
                      setDefaultCity(indexCity);
                    }
                  } else {
                    setDefaultEstado(defaultEstado);
                    setDefaultCity(defaultCity);
                  }
                } else {
                  showToast("CEPDiferente");
                  useFormRef.current?.setFieldValue("enderecoCEP", "");
                }
              } else {
                setIsOpenCEP(true);
              }
            }
          })
          .catch((err) => {
            showToast("ErroCEP");
          });
      }
    },
    [
      setDefaultEstado,
      setDefaultCity,
      defaultEstado,
      defaultCity,
      localStorageCard?.Estado,
      cidades,
      showToast,
      listBanks,
    ]
  );

  const handleChangeEstado = useCallback(
    (e: any) => {
      if (e.target.firstChild) {
        const { data } = e.target.firstChild;
        if (data) {
          const indexUF = Estados.map((el) => el.label).indexOf(data);
          if (indexUF !== -1) {
            setDefaultEstado(indexUF);
          }
        }
      }
    },
    [setDefaultEstado]
  );

  const handleChangeCPFCNPJ = useCallback((e: any) => {
    const { value } = e.target;
    if (value.length > 14) {
      e.target.value = value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1/$2")
        .replace(/(\d{4})(\d)/, "$1-$2")
        .replace(/(-\d{2})(\d+?)$/, "$1");
    } else {
      e.target.value = value
        .replace(/\D/g, "")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1-$2")
        .replace(/(-\d{2})(\d+?)$/, "$1");
    }
  }, []);

  const handleChangeDataNascimento = useCallback((e: any) => {
    const { value } = e.target;
    if (value.length > 10) {
      e.target.value = "0";
    }
  }, []);

  const handleRemoveErrors = useCallback(() => {
    if (errorsAttr.length > 0) {
      errorsAttr.map((item) => {
        const element = document.getElementById(item);
        element?.classList.remove("inputError");
        return element;
      });
    }
  }, [errorsAttr]);

  const handleSetErrors = useCallback((data: any) => {
    Object.keys(data).forEach((item) => {
      const element = document.getElementById(item);
      element?.setAttribute("class", "inputError");
    });
    setErrorsAttr(Object.keys(data));

    window.location.href = "#" + Object.keys(data)[0];
  }, []);

  const handleApiErrors = useCallback(
    (error: any, local: string) => {
      if (error.message === "Network Error") {
        if (!navigator.onLine) {
          showToast("error");
        }
      } else {
        showToast("error");
      }
    },
    [showToast]
  );

  const dataSend = useCallback(
    (data: any) => {
      let object: IDataForm = {
        tipoPessoa: pessoa,
        idCard: idCard,
        idFase: "5",
        numeroInstalacao: numeroInstalacao,
        dataVencimentoFatura: data.dataVencimentoFatura,
        formaPagamento: formaPagamento,
        telefoneLigacao: data.telefoneLigacao,

        endereco: {
          CEP: data.enderecoCEP,
          estado: data.enderecoestado,
          cidade: data.enderecocidade,
          bairro: data.enderecobairro,
          logradouro: data.enderecologradouro,
          numero: data.endereconumero,
          complemento: data.enderecocomplemento,
        },

        pessoaFisica: {
          nomeCompleto: data.pessoaFisicaNomeCompleto,
          CPF: data.pessoaFisicaCPF,
          email: data.pessoaFisicaEmail,
          telefone: data.pessoaFisicaTelefone,
          dataNascimento: data.pessoaFisicadataNascimento,
          RG: "",
          orgaoEmissor: "",
          profissao: "",
          estadoCivil: "",
          naturalidade: "",
          nacionalidade: "",
        },

        pessoaJuridica: {
          razaoSocial: data.pessoaJuridicaRazaoSocial,
          CNPJ: data.pessoaJuridicaCNPJ,
          emailEmpresa: data.pessoaJuridicaEmailEmpresa,
          telefoneEmpresa: data.pessoaJuridicaTelefoneEmpresa,
          responsavel: {
            nomeCompleto: data.pessoaJuridicaresponsavelnomeCompleto,
            CPF: data.pessoaJuridicaresponsavelCPF,
            email: data.pessoaJuridicaresponsavelemail,
            telefone: data.pessoaJuridicaresponsaveltelefone,
            dataNascimento: data.pessoaJuridicaNascimento,
          },
        },
      };
      return object;
    },
    [pessoa, idCard, formaPagamento, numeroInstalacao]
  );

  const handleGoogleAds = useCallback(() => {
    gtag("event", "conversion", {
      send_to: "AW-380215018/yb2SCMTg0d0DEOq9prUB",
      event_callback: window.location.href,
    });
  }, []);

  const handleChangeStepperNext = useCallback(() => {
    api
      .get("/csp/cliente/consultar/card/" + idCard)
      .then((res) => {
        writeStorage({
          key: "card",
          object: {
            NomeTitularConta: res.data["empresa"],
            OndeEconomizar: res.data["onde_voc_quer_economizar"],
            Pessoa: res.data["tipo"],
            CNPJrepresentante: res.data["cnpj_do_representante_1"],
            Estado: res.data["estado"],
            Cidade: res.data["cidade"],
            Bairro: res.data["bairro"],
            Rua: res.data["rua"],
            Numero: res.data["n_mero"],
            Complemento: res.data["complemento"],
            Classe: res.data["classe"],
            Subclasse: res.data["subclasse"],
            Jan: res.data["jan"],
            Fev: res.data["fev"],
            Mar: res.data["mar"],
            Abr: res.data["abr"],
            Mai: res.data["mai"],
            Jun: res.data["jun"],
            Jul: res.data["jul"],
            Ago: res.data["ago"],
            Set: res.data["set"],
            Out: res.data["out"],
            Nov: res.data["nov"],
            Dez: res.data["dez"],
            MediaConsumo: res.data["m_dia_de_consumo"],
            FormaPagamento: res.data["forma_de_pagamento"],
            CEPvalidoCard: 1,
            RazaoSocialCard: res.data["raz_o_social"],
            Email: res.data["email"],
            EmailDoResponsavel: res.data["email_do_respons_vel_legal"],
            TelefoneTitularConta: res.data["telefone_do_titular_da_conta"],
            TelefoneResponsavelLegal: res.data["telefone_do_respons_vel_legal"],
            cpfCnpjCard:
              res.data["tipo"] === "PJ" ? res.data["cnpj"] : res.data["cpf"],
            DataNascimentoTitular: res.data["data_de_nascimento_do_titular"]
              ?.split(" ")[0]
              .split("/")
              .reverse()
              .join("-"),
            NomeResponsavelLegal: res.data["nome_do_respons_vel_legal"],
            CPF:
              res.data["tipo"] === "PF"
                ? res.data["cpf"]
                : res.data["cpf_do_respons_vel_legal"],
            CEP: res.data["cep"],
            NumeroInstalacao: res.data["n_mero_da_instala_o_cemig_1"],
            DataVencimentoFatura:
              res.data["data_de_vencimento_da_fatura_cemig"],
            Banco: res.data["banco"],
            CodBanco: res.data["codban"],
            Agencia: res.data["ag_ncia"],
            Conta: res.data["conta"],
            Concessionaria: res.data["concession_ria"],
            TelefoneLigacao: res.data["telefone_contato_para_liga_o"],
          },
        });

        if (res.status === 200) {
          window.location.href = "/onboarding/step/4";
        }
      })
      .catch((error) => {
        setLoad(false);
        showToast("error");
      });
  }, [idCard, setLoad, showToast]);

  // const handleSendFatura = useCallback(
  //   async (id: any, unidade: any) => {
  //     setLoad(true);
  //     await api
  //       .post("/csp/usuario/fatura/enviar/", {
  //         idCard: String(id),
  //         numeroInstalacao: String(unidade),
  //         tipoArquivo: uploadedImage?.tipoArquivo,
  //         fatura: uploadedImage?.fatura,
  //       })
  //       .then((res) => {
  //         if (res.status === 200) {
  //           setLoad(false);
  //           handleChangeStepperNext();
  //         }
  //       })
  //       .catch((error) => {
  //         setLoad(false);
  //         if (error.response.status === 404) {
  //           showToast("erroSendFatura");
  //           setLoad(false);
  //         }
  //         if (error.response.status === 500) {
  //           showToast("erroSendFatura");
  //           setLoad(false);
  //         }
  //       });
  //   },
  //   [setLoad, showToast, uploadedImage, handleChangeStepperNext]
  // );

  const TypesDocuments = ["PDF", "PNG", "JPG", "JPEG"];

  function setBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        const dataURL = reader.result as string;
        const base64Data = dataURL?.split(",")[1];
        const tipoArquivo = dataURL?.split(",")[0];

        const data = {
          fatura: base64Data,
          tipoArquivo: tipoArquivo,
        };
        resolve(data);
      };

      reader.onerror = function (error) {
        console.log("erro");
        reject(error);
      };
    });
  }

  const max_file_size = 5 * 1024 * 1024;

  const isValidFileType = (file: any) => {
    const fileExtension = file.name.split(".").pop()?.toUpperCase();
    return TypesDocuments.includes(fileExtension);
  };

  // const handleImageChange = async (image: any) => {
  //   if (image?.size <= max_file_size) {
  //     if (isValidFileType(image)) {
  //       const imageData = await setBase64(image);
  //       setUploadedImage(imageData);
  //     }
  //   } else if (image !== null) {
  //     showToast("LimiteTamanhoArquivo");
  //   }
  // };

  const handleChangeNumeroInstalacao = useCallback(
    (e: any) => {
      const { value } = e.target;
      e.target.value = value.replace(/\D/g, "");

      setNumeroInstalacao(value.replace(/\D/g, ""));

      const limit = 15;
      if (value.length > limit) {
        showToast("Limite");
        e.target.value = value.slice(0, limit);
      }
    },
    [showToast]
  );

  const handleCPFValidation = async (e: any) => {
    const { value } = e.target;
    if (!value.trim()) {
      useFormRef.current?.setFieldError("pessoaFisicaCPF", "");
      useFormRef.current?.setFieldError("pessoaJuridicaresponsavelCPF", "");
      return;
    }

    if (pessoa === "PF") {
      try {
        const schema = Yup.object().shape({
          pessoaFisicaCPF: Yup.string().test(
            "CPF",
            "Informe um CPF válido",
            () => cpf.isValid(value.replace(/[^\d]+/g, ""))
          ),
        });

        const data = { pessoaFisicaCPF: value };

        await schema.validate(data, {
          abortEarly: false,
        });

        useFormRef.current?.setFieldError("pessoaFisicaCPF", "");
      } catch (error: any) {
        useFormRef.current?.setFieldError("pessoaFisicaCPF", error.message);
      }
    }
    if (pessoa === "PJ") {
      try {
        const schema = Yup.object().shape({
          pessoaJuridicaresponsavelCPF: Yup.string().test(
            "CPF",
            "Informe um CPF válido",
            () => cpf.isValid(value.replace(/[^\d]+/g, ""))
          ),
        });

        const data = { pessoaJuridicaresponsavelCPF: value };

        await schema.validate(data, {
          abortEarly: false,
        });

        useFormRef.current?.setFieldError("pessoaJuridicaresponsavelCPF", "");
      } catch (error: any) {
        useFormRef.current?.setFieldError(
          "pessoaJuridicaresponsavelCPF",
          error.message
        );
      }
    }
  };

  const handleCNPJValidation = async (e: any) => {
    const { value } = e.target;

    if (!value.trim()) {
      useFormRef.current?.setFieldError("pessoaJuridicaCNPJ", "");
      return;
    }
    try {
      const schema = Yup.object().shape({
        pessoaJuridicaCNPJ: Yup.string().test(
          "CNPJ",
          "Informe um CNPJ válido",
          () => cnpj.isValid(value.replace(/[^\d]+/g, ""))
        ),
      });

      const data = { pessoaJuridicaCNPJ: value };

      await schema.validate(data, {
        abortEarly: false,
      });

      useFormRef.current?.setFieldError("pessoaJuridicaCNPJ", "");
    } catch (error: any) {
      useFormRef.current?.setFieldError("pessoaJuridicaCNPJ", error.message);
    }
  };

  const handleSendFiles = useCallback(async () => {
    try {
      let filesNames: { name: string; path: string }[] = [];
      if (files !== null && files.length > 0) {
        for (const item of Array.from(files)) {
          const response = await api.post<UploadRes>("/csp/fatura/gerar/link", {
            nomeArquivo: item.name.replace(/[^a-zA-Z0-9. ]/g, ""),
          });
          if (response.status === 200) {
            const { signedUrl, filename } = response.data;
            const putRes = await api.put(signedUrl, item);
            if (putRes.status === 200)
              filesNames.push({ name: item.name, path: filename });
          }
        }
      }
      if (filesNames.length > 0) return filesNames;
      return [];
    } catch (error) {
      const axiosError = error as AxiosError;
      console.log(axiosError.message);
    }
    return [];
  }, [files]);

  const storeImageData = useCallback(async () => {
    const response = await api.get<{
      fotos: { url: string; nomeArquivo: string }[];
    }>(`/csp/usuario/consulta/link/${idCard}`);
    if (response.status === 200) {
      setFotos(response.data.fotos);
    } else {
      showToast("error");
    }
  }, [idCard, showToast]);

  const onDeleteFile = useCallback(
    async (fullUrl: string): Promise<number> => {
      try {
        setLoad(true);
        const url = new URL(fullUrl);
        const pathname = url.pathname;
        const uploadsIndex = pathname.indexOf("/uploads");
        const specificPath = pathname.substring(uploadsIndex + 1);

        const body = { idCard: String(idCard), fotos: specificPath };

        const response = await api.post("/csp/fatura/excluir", body);

        if (response.status === 200) {
          showToast("faturaExcluida");
          const updatedFotos = fotos.filter((foto) => foto.url !== fullUrl);
          setFotos(updatedFotos);
        }
        setLoad(false);
        return response.status;
      } catch (error) {
        setLoad(false);
        showToast("errorSend");
        return 500;
      }
    },
    [fotos, idCard, setLoad, showToast]
  );

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        useFormRef.current?.setErrors({});
        handleRemoveErrors();

        const {
          pessoaFisicaCPF,
          pessoaJuridicaresponsavelCPF,
          pessoaJuridicaCNPJ,
          pessoaFisicadataNascimento,
          enderecoestado,
        } = data;

        let schema = Yup.object();

        if (pessoa === "PF") {
          schema = schema.shape({
            isValid: Yup.boolean().default(true),
            pessoaFisicaNomeCompleto: Yup.string().required(
              "Nome do Titular é obrigatório"
            ),
            pessoaFisicaTelefone: Yup.string().required(
              "Informe um telefone ou celular"
            ),
            pessoaFisicaCPF: Yup.mixed()
              .required("Informe um CPF")
              .test(
                "CPF",
                "Informe um CPF válido",
                () =>
                  cpf.isValid(pessoaFisicaCPF.replace(/[^\d]+/g, "")) === true
              )
              .required("Necessário informar um CPF"),
            pessoaFisicaEmail: Yup.string()
              .email("Informe um email válido")
              .required("Informe um email"),
            pessoaFisicadataNascimento: Yup.string()
              .required("Informe a data de Nascimento")
              .test(
                "Data",
                "Informe uma data de válida",
                () =>
                  /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/.test(
                    pessoaFisicadataNascimento
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  ) === true
              )
              .test(
                "Data",
                "Informe uma data menor",
                () => pessoaFisicadataNascimento < "2100-01-01"
              )
              .test(
                "Data",
                "Informe uma data atual",
                () => pessoaFisicadataNascimento > "1900-01-01"
              ),
          });
        }

        if (pessoa === "PJ") {
          schema = schema.shape({
            pessoaJuridicaRazaoSocial: Yup.string().required(
              "Razão social é obrigatório"
            ),
            pessoaJuridicaTelefoneEmpresa: Yup.string().required(
              "Informe um telefone ou celular"
            ),
            pessoaJuridicaNascimento: Yup.string().required(
              "Informe a data de Nascimento"
            ),
            pessoaJuridicaCNPJ: Yup.mixed()
              .test(
                "CNPJ",
                "Informe um CNPJ válido",
                () =>
                  cnpj.isValid(pessoaJuridicaCNPJ.replace(/[^\d]+/g, "")) ===
                  true
              )
              .required("Necessário informar um CNPJ"),
            pessoaJuridicaresponsavelnomeCompleto: Yup.string().required(
              "Necessário informar nome do responsável"
            ),
            pessoaJuridicaresponsavelCPF: Yup.string()
              .required("Informe o CPF do responsável")
              .test(
                "CPF",
                "Informe um CPF válido",
                () =>
                  cpf.isValid(
                    pessoaJuridicaresponsavelCPF.replace(/[^\d]+/g, "")
                  ) === true
              )
              .required("Necessário informar um CPF"),
            pessoaJuridicaresponsavelemail: Yup.string()
              .email("Informe um email válido")
              .required("Necessário informar um email"),
            pessoaJuridicaresponsaveltelefone: Yup.string().required(
              "Informe o telefone do responsável"
            ),
          });
        }

        schema = schema.shape({
          enderecoCEP: Yup.string().required("Informe o CEP"),
          enderecoestado: Yup.string().required(
            "Informe a unidade da federação"
          ),
          telefoneLigacao: Yup.string().required(
            "Informe um telefone para contato"
          ),
          enderecocidade: Yup.string().required("Informe a cidade"),
          enderecobairro: Yup.string().required("Informe o bairro"),
          enderecologradouro: Yup.string().required("Informe um logradouro"),
          endereconumero: Yup.string().required("Informe o número"),
          dataVencimentoFatura: Yup.string().required(
            "Informe data do vencimento"
          ),
          numeroInstalacao: Yup.string().required(
            "Informe a número de instalação"
          ),
        });

        if (enderecoestado === "Minas Gerais") {
          schema = schema.shape({
            numeroInstalacao: Yup.string()
              .required("Informe a número de instalação")
              .max(15, "O número da instalação é composto por 15 dígitos"),
          });
        }

        if (enderecoestado === "MG") {
          schema = schema.shape({
            numeroInstalacao: Yup.string()
              .required("Informe a número de instalação")
              .max(15, "O número da instalação é composto por 15 dígitos"),
          });
        }

        await schema.validate(data, {
          abortEarly: false,
        });
        setLoad(true);
        var filesData: string[] = [];
        if (files !== null && files?.length > 0) {
          filesData = (await handleSendFiles()).map((item) => item.path);
        }
        const sendData = dataSend(data);

        await api
          .post("/csp/usuario/alterar/dadosTitular/", {
            faturas:
              filesData && filesData.length > 0 ? filesData.join(";") : "",
            ...sendData,
          })
          .then(async (res) => {
            if (res.status === 200) {
              if (CEPvalido !== 1) {
                setIsOpenCEP(true);
              } else {
                writeStorage({
                  key: "holderdata",
                  object: {
                    sendData,
                  },
                });
                setLoad(false);
                handleGoogleAds();
                storeImageData();
                handleChangeStepperNext();
              }
            }
          })
          .catch((error) => {
            setLoad(false);
            showToast("error");
          });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          useFormRef.current?.setErrors(errors);
          handleSetErrors(useFormRef.current?.getErrors());
        } else {
          handleApiErrors(err, "salvar registro");
        }
      }
    },
    [
      handleRemoveErrors,
      pessoa,
      files,
      dataSend,
      setLoad,
      handleSendFiles,
      CEPvalido,
      handleGoogleAds,
      storeImageData,
      handleChangeStepperNext,
      showToast,
      handleSetErrors,
      handleApiErrors,
    ]
  );

  const handleChangeValue = (e: any) => {
    const { value } = e.target;
    e.target.value = value.replace(/\D/g, "");

    const limit = e.target.maxLength;
    if (value.length >= limit) {
      showToast("Limite");
    }
  };

  document.addEventListener("keydown", function (e) {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  });

  const handleLimit = useCallback(
    (e: any) => {
      const limit = e.target.maxLength;
      const value = e.target.value;
      if (value.length >= limit) {
        showToast("Limite");
      }
    },
    [showToast]
  );

  const handleSanitizeEmail = useCallback(
    (e: any) => {
      const { value } = e.target;
      const sanitizedValue = value.replace(/[^a-zA-Z0-9@._-]/g, "");

      e.target.value = sanitizedValue;

      if (sanitizedValue !== value) {
        showToast("Sanitize");
      }
    },
    [showToast]
  );

  const handleInputSanitizeAndLimit = useCallback(
    (e: any) => {
      handleSanitizeEmail(e);
      handleLimit(e);
    },
    [handleSanitizeEmail, handleLimit]
  );

  useEffect(() => {
    storeImageData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <ModalCEP isOpen={modalIsOpenCEP} onRequestClose={closeModal} />
      <BigTitle>Preencha os dados do titular da unidade consumidora:</BigTitle>
      <DivForm>
        <Form
          ref={useFormRef}
          onSubmit={handleSubmit}
          placeholder={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <DivInicio>
            <Input
              type="text"
              name={
                pessoa === "PF"
                  ? "pessoaFisicaNomeCompleto"
                  : "pessoaJuridicaRazaoSocial"
              }
              placeholder={pessoa === "PF" ? "Nome do Titular" : "Razão Social"}
              defaultValue={
                pessoa === "PF"
                  ? localStorageCard?.NomeTitularConta
                  : localStorageCard?.RazaoSocialCard
              }
              label={pessoa === "PF" ? "Nome do Titular" : "Razão Social"}
              id={
                pessoa === "PF"
                  ? "pessoaFisicaNomeCompleto"
                  : "pessoaJuridicaRazaoSocial"
              }
              maxLength={100}
              onChange={(e) => handleLimit(e)}
            ></Input>

            <Input
              type="text"
              name={
                pessoa === "PF"
                  ? "pessoaFisicaEmail"
                  : "pessoaJuridicaEmailEmpresa"
              }
              placeholder="E-mail"
              label="E-mail"
              defaultValue={localStorageCard?.Email}
              id={
                pessoa === "PF"
                  ? "pessoaFisicaEmail"
                  : "pessoaJuridicaEmailEmpresa"
              }
              maxLength={100}
              onChange={(e) => handleInputSanitizeAndLimit(e)}
            ></Input>
          </DivInicio>
          <DivEmpresa>
            <span style={pessoa === "PJ" ? { display: "none" } : {}}>
              <Input
                type="text"
                name={pessoa === "PF" ? "telefoneLigacao" : "none"}
                placeholder="Telefone"
                label="Telefone"
                onChange={handleChangeTelefone}
                defaultValue={localStorageCard?.TelefoneLigacao}
                id={pessoa === "PF" ? "telefoneLigacao" : "none"}
              ></Input>
            </span>
            <Input
              type="text"
              name={
                pessoa === "PF"
                  ? "pessoaFisicaTelefone"
                  : "pessoaJuridicaTelefoneEmpresa"
              }
              placeholder="Telefone ou celular"
              label={pessoa === "PF" ? "WhatsApp" : "Telefone ou celular"}
              onChange={handleChangeTelefone}
              defaultValue={localStorageCard?.TelefoneTitularConta}
              id={
                pessoa === "PF"
                  ? "pessoaFisicaTelefone"
                  : "pessoaJuridicaTelefoneEmpresa"
              }
              maxLength={20}
            ></Input>
            <Input
              type="text"
              name={pessoa === "PF" ? "pessoaFisicaCPF" : "pessoaJuridicaCNPJ"}
              placeholder={pessoa === "PF" ? "CPF" : "CNPJ"}
              defaultValue={localStorageCard?.cpfCnpjCard}
              label={pessoa === "PF" ? "CPF" : "CNPJ"}
              onChange={handleChangeCPFCNPJ}
              onBlur={
                pessoa === "PF" ? handleCPFValidation : handleCNPJValidation
              }
              id={pessoa === "PF" ? "pessoaFisicaCPF" : "pessoaJuridicaCNPJ"}
              maxLength={18}
            ></Input>
            <DivPF
              style={
                pessoa === "PF" ? { display: "grid" } : { display: "none" }
              }
            >
              <DivEmpresa>
                <Input
                  type="date"
                  name="pessoaFisicadataNascimento"
                  placeholder="Data de Nascimento"
                  label="Data de Nascimento"
                  onChange={handleChangeDataNascimento}
                  defaultValue={localStorageCard?.DataNascimentoTitular}
                  id="pessoaFisicadataNascimento"
                ></Input>
              </DivEmpresa>
            </DivPF>
          </DivEmpresa>

          <DivResponsavel
            style={pessoa === "PF" ? { display: "none" } : { display: "grid" }}
          >
            <p style={{ fontFamily: "Open Sans, sans-serif" }}>
              Dados do responsável legal
            </p>
            <DivEmpresa>
              <Input
                type="text"
                name="pessoaJuridicaresponsavelnomeCompleto"
                placeholder="Nome completo"
                label="Nome completo"
                defaultValue={localStorageCard?.NomeResponsavelLegal}
                id="pessoaJuridicaresponsavelnomeCompleto"
                maxLength={50}
                onChange={(e) => handleLimit(e)}
              ></Input>
              <Input
                type="text"
                name="pessoaJuridicaresponsavelCPF"
                placeholder="CPF"
                label="CPF"
                onChange={handleChangeCPFCNPJ}
                onBlur={handleCPFValidation}
                defaultValue={localStorageCard?.CPF}
                id="pessoaJuridicaresponsavelCPF"
              ></Input>
              <Input
                type="date"
                name="pessoaJuridicaNascimento"
                placeholder="Data de Nascimento"
                label="Data de Nascimento"
                onChange={handleChangeDataNascimento}
                defaultValue={localStorageCard?.DataNascimentoTitular}
                id="pessoaFisicadataNascimento"
              ></Input>
              <Input
                type="text"
                name="pessoaJuridicaresponsavelemail"
                placeholder="E-mail"
                label="E-mail"
                defaultValue={localStorageCard?.EmailDoResponsavel}
                id="pessoaJuridicaresponsavelemail"
                maxLength={1000}
                onChange={(e) => handleInputSanitizeAndLimit(e)}
              ></Input>
              <Input
                type="text"
                name={pessoa === "PJ" ? "telefoneLigacao" : "none"}
                placeholder="Telefone"
                label="Telefone"
                onChange={handleChangeTelefone}
                defaultValue={localStorageCard?.TelefoneLigacao}
                id={pessoa === "PJ" ? "telefoneLigacao" : "none"}
              ></Input>
              <Input
                type="text"
                name="pessoaJuridicaresponsaveltelefone"
                placeholder="WhatsApp"
                label="WhatsApp"
                onChange={handleChangeTelefone}
                defaultValue={localStorageCard?.TelefoneResponsavelLegal}
                id="pessoaJuridicaresponsaveltelefone"
              ></Input>
            </DivEmpresa>
          </DivResponsavel>
          <p style={{ fontFamily: "Open Sans, sans-serif" }}>
            Dados de endereço:
          </p>
          <DivEmpresa>
            <Input
              type="text"
              name="enderecoCEP"
              placeholder="CEP"
              label="CEP"
              onChange={handleChangeCEP}
              onBlur={handleBlurCEP}
              defaultValue={localStorageCard?.CEP}
              id="enderecoCEP"
            ></Input>
            <span onClick={() => disableInputCep()}>
              <Input
                type="text"
                name="enderecoestado"
                placeholder="Estado"
                label="Estado"
                onChange={handleChangeEstado}
                defaultValue={localStorageCard?.Estado}
                id="enderecoestado"
                disabled
              ></Input>
            </span>
            <span onClick={() => disableInputCep()}>
              <Input
                type="text"
                name="enderecocidade"
                placeholder="Cidade"
                label="Cidade"
                defaultValue={localStorageCard?.Cidade}
                id="enderecocidade"
                disabled
                maxLength={1000}
                onChange={(e) => handleLimit(e)}
              ></Input>
            </span>
            <Input
              type="text"
              name="enderecobairro"
              placeholder="Bairro"
              label="Bairro"
              defaultValue={localStorageCard?.Bairro}
              id="enderecobairro"
              maxLength={75}
              onChange={(e) => handleLimit(e)}
            ></Input>
            <Input
              type="text"
              name="enderecologradouro"
              placeholder="Logradouro"
              label="Logradouro"
              defaultValue={localStorageCard?.Rua}
              id="enderecologradouro"
              maxLength={100}
              onChange={(e) => handleLimit(e)}
            ></Input>
            <Input
              type="text"
              name="endereconumero"
              placeholder="Número"
              label="Número"
              onChange={handleChangeValue}
              defaultValue={localStorageCard?.Numero}
              id="endereconumero"
              maxLength={20}
            ></Input>
            <Input
              type="text"
              name="enderecocomplemento"
              placeholder="Complemento"
              label="Complemento"
              defaultValue={localStorageCard?.Complemento}
              id="enderecocomplemento"
              maxLength={200}
              onChange={(e) => handleLimit(e)}
            ></Input>
          </DivEmpresa>

          <div style={{ display: "grid" }}>
            <p style={{ fontFamily: "Open Sans, sans-serif" }}>
              Dados da fatura:
            </p>

            <DivEmpresa>
              <Tooltip title="Preencha o CEP para continuar" placement={"top"}>
                <div style={!canProceedToInvoiceData ? { opacity: 0.5 } : {}}>
                  <Input
                    disabled={!canProceedToInvoiceData}
                    type="text"
                    name="numeroInstalacao"
                    defaultValue={localStorageCard?.NumeroInstalacao}
                    placeholder="Número da instalação"
                    label="Número da instalação"
                    onChange={handleChangeNumeroInstalacao}
                    id="numeroInstalacao"
                  ></Input>
                </div>
              </Tooltip>

              <Input
                type="text"
                name="dataVencimentoFatura"
                placeholder="Dia de vencimento fatura"
                label="Dia de vencimento fatura"
                maxLength={2}
                onChange={onSanitizeValueDay}
                defaultValue={localStorageCard?.DataVencimentoFatura}
                id="dataVencimentoFatura"
              ></Input>
            </DivEmpresa>
          </div>
          <p style={{ fontFamily: "Open Sans, sans-serif" }}>
            Envie uma cópia de sua fatura (opcional )
          </p>
          <DivEmpresa>
            <DivTableDrag>
              <InputFileMultiple
                onChange={(val) => setFiles(val)}
                onDelete={onDeleteFile}
                callbackFiles={fotos}
              />
            </DivTableDrag>
            <div className="divHiddenBottom">
              <Input name="hidden" maxLength={1000}></Input>
            </div>
          </DivEmpresa>
          <div className="GridButtonsGrafico">
            <DivButton>
              <Button
                id="btnStep4Back"
                className="buttonBack"
                onClick={handleChangeStepperBack}
              >
                Voltar
              </Button>
            </DivButton>
            <DivButton>
              <Button id="btnStep4Next" className="buttonSend" type="submit">
                Continuar
              </Button>
            </DivButton>
          </div>
        </Form>
      </DivForm>
    </>
  );
};

export default HolderData;
